/**
 * @generated SignedSource<<caaf1222eee2525329079525fc89c17d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ui_navigationBoardActionMenu_BoardActions$data = {
  readonly projectId: string | null | undefined;
  readonly projectKey: string;
  readonly projectType: JiraProjectType | null | undefined;
  readonly " $fragmentType": "ui_navigationBoardActionMenu_BoardActions";
};
export type ui_navigationBoardActionMenu_BoardActions$key = {
  readonly " $data"?: ui_navigationBoardActionMenu_BoardActions$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_navigationBoardActionMenu_BoardActions">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_navigationBoardActionMenu_BoardActions",
  "selections": [
    {
      "alias": "projectKey",
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "projectId"
    },
    {
      "kind": "ScalarField",
      "name": "projectType"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "c4890e10b4a9bc525d38501ea5a616a3";

export default node;
